'use client';

import { trackExperimentView } from '@hc-frontend/third-party-snowplow';
import { useIdleTimer } from 'react-idle-timer';

import { useSurveyInactivityModal } from './provider';

type SurveyInactivityModalTriggerProps = {
  /**
   * Timeout in milliseconds for the inactivity modal to open.
   */
  timeout: number;

  /**
   * Throttle time in milliseconds for the events that will be tracked. Should always be less than the timeout.
   */
  eventsThrottle: number;

  experimentName?: string;
  experimentTreatment?: string;
};

export function SurveyInactivityModalTrigger({
  timeout,
  eventsThrottle,
  experimentName,
  experimentTreatment,
}: SurveyInactivityModalTriggerProps) {
  const { setIsOpen } = useSurveyInactivityModal();

  const handleOpen = () => {
    if (experimentName && experimentTreatment) {
      trackExperimentView({
        experimentName,
        variantName: experimentTreatment,
        splitSource: 'amplitude',
      });
    }

    if (experimentTreatment === 'variant') {
      setIsOpen(true);
    }
  };

  useIdleTimer({
    timeout,
    eventsThrottle,
    onIdle: handleOpen,
    stopOnIdle: true,
  });

  return null;
}
